import React, {useState} from "react";

const ToggleButton = ({ allStudents , setAllStudents }) => {

    return (
        <div style={{
            width: "200px",
            direction: "ltr",
            display: "flex",
            flexDirection: "column",
            transform: "translateY(5%)",
            margin: "auto",
            boxShadow: "var(--main-shadow)",
            borderRadius: "5px",

        }}>
            <div style={{
                height: "40px",
                width: "100%",
                backgroundColor: "white",
                borderRadius: "5px",
                position: "relative",
                cursor: "pointer",
                placeItems: "center",
                display: "flex",
            }} onClick={() => setAllStudents(!allStudents)}>
                <div style={{
                    height: "40px",
                    borderRadius: "5px",
                    position: "absolute",
                    width: "50%",
                    boxShadow: "0 2px 15px rgba(0,0,0,.15)",
                    transition: "transform .3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                    transform: allStudents ? "" : "translateX(100%)",
                    backgroundColor: "var(--blue)",
                }} />
                <div style={{
                    width: "100%",
                    position: "absolute",
                    display: "flex",
                    justifyContent: "space-around",
                    userSelect: "none"
                }}>
                    <p style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: allStudents ? "white" : "var(--blue)"
                    }}>همه محصلان</p>
                    <p style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: allStudents ? "var(--blue)" : "white"
                    }}>محصلان برحال</p>
                </div>
            </div>
        </div>
    );
};

export default ToggleButton;
